const galleryId = 64;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_731859331.jpg","sh_1055611979.jpg","sh_1522470902.jpg","sh_478971523.jpg","sh_1090846355.jpg","sh_1678807423.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Dentures'));

group = ["sh_1426462496.jpg","sh_1739391977.jpg","sh_1739391980.jpg","sh_1277759128.jpg","sh_1277759143.jpg","sh_1494043040.jpg","sh_1494043049.jpg","sh_1399857905.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Implant supported dentures'));

group = ["sh_713522740.jpg","sh_1376727602.jpg","sh_1530693941.jpg","sh_1555107653.jpg","sh_1713449392.jpg","sh_93396676.jpg","sh_1376727611.jpg","sh_1408362356.jpg","sh_1727881345.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Implant supported overdentures'));

group = ["sh_233097139.jpg","sh_601865408.jpg","sh_1713449395.jpg","sh_1713449398.jpg","sh_227755375_1.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Bar retained overdentures'));

group = ["sh_65238034.jpg","sh_534466816.jpg","sh_1070875265.jpg","sh_1135506995.jpg","sh_1407799244.jpg","sh_1771550267.jpg","sh_713959078.jpg","sh_713959090.jpg","sh_622644611.jpg","sh_1537746335.jpg","sh_355346009.jpg","sh_1137607676.jpg","sh_97915919.jpg"];
group.forEach((i) => addItemToGroup(i, '5. Partial dentures'));

group = ["sh_178995689.jpg","sh_217891726.jpg","sh_416123827.jpg","sh_478971583.jpg","sh_1042137034.jpg","sh_1555907489.jpg","sh_708019222.jpg"];
group.forEach((i) => addItemToGroup(i, '6. Partial dentures with metal base'));

group = ["sh_120486451.jpg","sh_120486484.jpg","sh_416123830.jpg","sh_427105573.jpg","sh_699898009.jpg","sh_713161084.jpg","sh_1023591571.jpg","sh_1066363349.jpg","sh_1104023060.jpg","sh_120486457.jpg","sh_121276789.jpg","sh_133842902.jpg","sh_343850504.jpg"];
group.forEach((i) => addItemToGroup(i, '7. Dentures with clasps'));

group = ["sh_217891540.jpg","sh_221954647.jpg"];
group.forEach((i) => addItemToGroup(i, '8. Preci-vertix'));

group = ["sh_1069078964.jpg","sh_1165261312.jpg","sh_1366012427.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_1713875839.jpg","sh_133842905.jpg","sh_148407104.jpg","sh_148407122.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

group = ["sh_127096880.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_new'));

export default items;
